import { useMemo } from 'react'
import { useConnections } from './connectionsHooks'
import { useCurrentUser } from 'features/users/hooks/userQueryHooks'
import { getConnectionsWithViewerCredentials } from 'features/builder/state/viewerCredentials'
import { DemoMap, Map } from 'features/maps/types'
import { useMapDatasets } from 'features/maps/hooks/mapsHooks'

export function useViewerMapCredentials(map?: Map | DemoMap) {
  const { data: connections } = useConnections()
  const currentUser = useCurrentUser()
  const { data: datasets } = useMapDatasets(map?.id, { allowCurrentMap: true })

  return useMemo(() => {
    if (!connections || !currentUser || !datasets) {
      return {
        connectionsWithCredentialsAttached: [],
        connectionsWithCredentialsEnabled: [],
        someCredentialsAttached: false
      }
    }
    const connectionsWithCredentialsEnabled = getConnectionsWithViewerCredentials(datasets, connections)
    const connectionsWithCredentialsAttached = connectionsWithCredentialsEnabled.filter(
      (connection) => connection.viewerCredentialsAttached
    )
    const someCredentialsAttached = Boolean(
      connections &&
        connectionsWithCredentialsAttached.filter((connection) => connection.user_id !== currentUser?.user_id).length >
          0
    )

    return {
      connectionsWithCredentialsAttached,
      connectionsWithCredentialsEnabled,
      someCredentialsAttached
    }
  }, [connections, currentUser, datasets])
}
